/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(document).ready(function() {
		const discountUpdate = (variant) => {
			if(!variant) return;
		
			const discountEl = document.querySelector("[data-discount]");
		
			if (discountEl) {
				discountEl.classList.remove("hidden");
		
				const discountValueEl = discountEl.querySelector("[data-discount-value]");
				const price = variant.price;
				const comparePrice = variant.compare_at_price;
		
				if (price && comparePrice) {
					if(price !== comparePrice) {
						discountValueEl.innerText = `${Math.round(((comparePrice - price) / comparePrice) * 100)}`;
					} else {
						if (!discountEl.classList.contains("hidden")) {
							discountEl.classList.add("hidden");
						}
					}
				}
			}
		}

		const variantMetafieldTextUpdate = (variant) => {
			const productJsonEl = document.querySelector("[data-product-json]")
			const variantLabelEl = document.querySelector("[data-variant-custom-text]");

			if (variantLabelEl && productJsonEl) {
				const productJson = JSON.parse(productJsonEl.innerHTML);
				if (productJson) {
					const metaFields = productJson.variants_metafields;

					if (metaFields) {
						const selectedMetaVariant = metaFields.find(item => item.id === variant.id);
						
						if (selectedMetaVariant) {
							const customMetaText = selectedMetaVariant.metafields[0]?.custom_variant_text;

							if (customMetaText) {
								variantLabelEl.innerText = customMetaText;
								variantLabelEl.classList.remove("hidden");
							} else {
								variantLabelEl.innerText = "";
								if (!variantLabelEl.classList.contains("hidden")) variantLabelEl.classList.add("hidden");
							}
						}
					}
				}

			}
		}

		const hideDescriptionPartOnClick = () => {
			document.addEventListener("click", (e) => {
				if (e.target.closest("[data-variant-button]")) {
					const button = e.target.closest("[data-variant-button]");
					const customDescrEl = document.querySelector("[data-product-custom-description]");
					
					if(!customDescrEl) return;

					if (button.hasAttribute("data-hide-description")) {
						if (!customDescrEl.classList.contains("hide-text-part")) customDescrEl.classList.add("hide-text-part");
					} else {
						customDescrEl.classList.remove("hide-text-part");
					}
				}
			})
		}

		document.addEventListener('variant:changed', function(event) {
		  var variant = event.detail.variant;
			discountUpdate(variant);
			variantMetafieldTextUpdate(variant);
		});

		hideDescriptionPartOnClick();

    setTimeout(function() {

    	var uniqueTextV = document.getElementsByClassName("v-stl-uniquetext");
			var shopTheLookHotspots = document.getElementsByClassName("ShopTheLook__Dot");

			shopTheLookHotspots[0]?.addEventListener("click", function() {
				uniqueTextV[0].classList.add('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[1]?.addEventListener("click", function() {
				uniqueTextV[1].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[2]?.addEventListener("click", function() {
				uniqueTextV[2].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[3]?.addEventListener("click", function() {
				uniqueTextV[3].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[4]?.addEventListener("click", function() {
				uniqueTextV[4].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[5]?.addEventListener("click", function() {
				uniqueTextV[5].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[6]?.addEventListener("click", function() {
				uniqueTextV[6].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
			});
		}, 5000);
});

// Seconds left to the next midnight: the visitor's own midnight, or midnight in the time zone set on the timer (data-tz).
// The chair bar sets America/New_York: the Christmas On Us draw (Nov 2026), so it matches the buy box timers.
function relaxeSecondsToMidnight(tz) {
    var d = new Date(), h = d.getHours(), m = d.getMinutes(), s = d.getSeconds();
    if (tz) {
        try {
            var o = {};
            new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' })
                .formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
            h = +o.hour % 24; m = +o.minute; s = +o.second;
        } catch (e) {}
    }
    return (86400 - (h * 3600 + m * 60 + s)) % 86400;
}

if (!window.customElements.get('announce-timer')) {
    class AnnounceTimer extends HTMLElement {
        connectedCallback() {
            const hourEl = this.querySelector('[data-timer-hours]');
            const minuteEl = this.querySelector('[data-timer-minutes]');
            const secondEl = this.querySelector('[data-timer-seconds]');
            const tz = this.getAttribute('data-tz') || '';
            const tick = () => {
                const left = relaxeSecondsToMidnight(tz);
                hourEl.textContent = String(Math.floor(left / 3600)).padStart(2, '0');
                minuteEl.textContent = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
                secondEl.textContent = String(left % 60).padStart(2, '0');
                // just after each whole second, like every other timer on the page
                this.timer = setTimeout(tick, 1010 - (Date.now() % 1000));
            };
            tick();
        }

        disconnectedCallback() {
            clearTimeout(this.timer);
        }
    }

    window.customElements.define('announce-timer', AnnounceTimer);
}
